module.exports = __webpack_public_path__ + "media/new_order_2.48fb23fb.mp3";